export default __webpack_public_path__ + "static/media/623.3ead9f94.jpg";